import { render, staticRenderFns } from "./pos-view.vue?vue&type=template&id=0da6eb48&scoped=true&"
import script from "./pos-view.vue?vue&type=script&lang=js&"
export * from "./pos-view.vue?vue&type=script&lang=js&"
import style0 from "./pos-view.vue?vue&type=style&index=0&id=0da6eb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da6eb48",
  null
  
)

export default component.exports